
import React, { useState, FormEvent } from 'react';



declare global {
    interface Window {
        Accept: {
            dispatchData: (
                secureData: SecureData,
                callback: (response: AcceptResponse) => void
            ) => void;
        };
    }
}

interface AuthData {
    clientKey: string;
    apiLoginID: string;
}

interface CardData {
    cardNumber: string;
    month: string;
    year: string;
    cardCode: string;
    fullName: string;
}

interface SecureData {
    authData: AuthData;
    cardData: CardData;
}

interface AcceptResponse {
    messages: {
        resultCode: string;
        message: {
            code: string;
            text: string;
        }[];
    };
    opaqueData?: {
        dataDescriptor: string;
        dataValue: string;
    };
}



function Authiorize() {


    const [cardNumber, setCardNumber] = useState('');
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [cvv, setCvv] = useState('');
    const [fullName, setFullName] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const handlePayment = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        const authData: AuthData = {
            clientKey: '48qPmpuKgaEp5d6ReVZFm8D7WM4DR24WhdMc862e9u3DbdTAmQcb4S2e2937bc9A',
            apiLoginID: '4dBF93uzn',
        };

        const cardData: CardData = {
            cardNumber,
            month,
            year,
            cardCode: cvv,
            fullName,
        };

        const secureData: SecureData = {
            authData,
            cardData,
        };

        if (!window.Accept) {
            setError('Accept.js not loaded.');
            setLoading(false);
            return;
        }

        window.Accept.dispatchData(secureData, async (response: AcceptResponse) => {
            console.log('response', response);
            if (response.messages.resultCode === 'Error') {
                setError(response.messages.message[0].text);
                setLoading(false);
            } else {
                const opaqueData = response.opaqueData;
                console.log('Send this to backend:', opaqueData);
                try {
                    const res = await fetch('https://dcs-api.lotusanalytics.com/api/v1/job/create-charge', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            opaqueData,
                            amount: 1000, // send the amount or other metadata you need
                        }),
                    });
                    const result = await res.json();

                    if (!res.ok) {
                        throw new Error(result.message || 'Payment failed');
                    }

                    // Success handling
                    console.log('Payment success:', result);
                } catch (err: any) {
                    setError(err.message || 'Something went wrong');
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    return (
        <form onSubmit={handlePayment}>
            <input
                placeholder="Full Name"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
            />
            <input
                placeholder="Card Number"
                value={cardNumber}
                onChange={(e) => setCardNumber(e.target.value)}
                required
            />
            <input
                placeholder="MM"
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                required
            />
            <input
                placeholder="YY"
                value={year}
                onChange={(e) => setYear(e.target.value)}
                required
            />
            <input
                placeholder="CVV"
                value={cvv}
                onChange={(e) => setCvv(e.target.value)}
                required
            />
            <button type="submit" disabled={loading}>
                {loading ? 'Processing...' : 'Pay'}
            </button>
            {error && <p style={{ color: 'red' }}>{error}</p>}
        </form>
    );

}

export default Authiorize;